import React from 'react';

import styled from 'styled-components';

type Props = {
  description: string;
  trigger: string;
  audience: string;
  messagingStrategy: string;
};

const Title = styled.div`
  margin-bottom: 8px;
  font-size: 20px;
  font-family: var(--font-bold);
`;

const Summary = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

const DetailList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const DetailItem = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

const DetailLabel = styled.span`
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const ActionPlanEmailCampaignDetails = ({ description, trigger, audience, messagingStrategy }: Props) => (
  <>
    <Title>Campaign Details</Title>
    <Summary>{description}</Summary>
    <DetailList>
      <DetailItem>
        <DetailLabel>Trigger:</DetailLabel> {trigger}
      </DetailItem>
      <DetailItem>
        <DetailLabel>Audience:</DetailLabel> {audience}
      </DetailItem>
      <DetailItem>
        <DetailLabel>Messaging Strategy:</DetailLabel> {messagingStrategy}
      </DetailItem>
    </DetailList>
  </>
);

export default ActionPlanEmailCampaignDetails;
